export default {"src":"/_next/static/media/boxGroup1.45f36d02.svg","height":149,"width":94};